import { useState } from "react";

import { AuthFooter } from "@shared/components/AuthFooter/AuthFooter";
import { AuthHeader } from "@shared/components/AuthHeader/AuthHeader";
import { AuthHeaderWrapper } from "@shared/components/AuthHeaderWrapper/AuthHeaderWrapper";
import { useLocation } from "@shared/react-router-dom/react-router-dom";
import type { StorePlatform } from "@shared/types/StorePlatform";
import { authRoutes } from "@unauthenticated/shared/data/authRoutes";
import { LinkExpiredNotificationPage } from "@unauthenticated/signupSignin/components/LinkExpiredNotificationPage/LinkExpiredNotificationPage";
import { LinkNotificationPage } from "@unauthenticated/signupSignin/components/LinkNotificationPage/LinkNotificationPage";
import { Page } from "@unauthenticated/signupSignin/components/Page/Page";
import { PageContent } from "@unauthenticated/signupSignin/components/PageContent/PageContent";
import { EmailFormContent } from "@unauthenticated/signupSignin/scenes/ContinueWithoutPasswordPage/EmailFormContent/EmailFormContent";
import { SuccessContent } from "@unauthenticated/signupSignin/scenes/ContinueWithoutPasswordPage/SuccessContent/SuccessContent";

import * as styles from "./ContinueWithoutPassword.styles";

interface HistoryState {
  source?: "RX_SIGN_IN";
  email?: string;
  page?: "success";
}

const ContinueWithoutPasswordPage = () => {
  const [email, setEmail] = useState(undefined);
  const { state }: { state: HistoryState } = useLocation();
  const [page, setPage] = useState<"email" | "success">(state?.page || "email");
  const isSwiftFillSignIn = state?.source === "RX_SIGN_IN";

  const { search } = useLocation();

  const linkEmail = new URLSearchParams(search).get("email");
  const linkHasError = new URLSearchParams(search).get("has_error") === "true";
  const linkStorePlatform = new URLSearchParams(search).get(
    "enable_shared_account"
  ) as StorePlatform;

  if (linkEmail && linkStorePlatform) {
    if (linkHasError) {
      return <LinkExpiredNotificationPage email={linkEmail} storePlatform={linkStorePlatform} />;
    }

    return <LinkNotificationPage email={linkEmail} storePlatform={linkStorePlatform} />;
  }

  const renderContent = () => {
    if (page === "email") {
      return <EmailFormContent email={email} setEmail={setEmail} setPage={setPage} />;
    } else {
      return (
        <SuccessContent
          email={state?.email || email}
          setPage={setPage}
          isSwiftFillSignIn={isSwiftFillSignIn}
        />
      );
    }
  };

  return (
    <Page>
      <PageContent>
        <AuthHeaderWrapper>
          <AuthHeader route={authRoutes.login} />
        </AuthHeaderWrapper>
        <div css={styles.contentLayout}>{renderContent()}</div>
      </PageContent>
      <AuthFooter />
    </Page>
  );
};

export { ContinueWithoutPasswordPage };
